import { useEffect, useState } from "react"


export const useCopy = () => {
  const [isSupported, setSupport] = useState(false);


  const copy = (text, { onSucess, onError }: { onSucess?, onError?}) => {
    navigator.clipboard.writeText(text)
      .then(onSucess)
      .catch(onError)
  }

  useEffect(
    () => {
      setSupport(!!navigator.clipboard);
    },
    []
  );

  return { copy, isSupported }
}